import { parseBoolean } from '@chatwoot/utils';

const {
  API_CHANNEL_NAME: apiChannelName,
  API_CHANNEL_THUMBNAIL: apiChannelThumbnail,
  APP_VERSION: appVersion,
  AZURE_APP_ID: azureAppId,
  BRAND_NAME: brandName,
  CHATWOOT_INBOX_TOKEN: chatwootInboxToken,
  CREATE_NEW_ACCOUNT_FROM_DASHBOARD: createNewAccountFromDashboard,
  DIRECT_UPLOADS_ENABLED: directUploadsEnabled,
  DISPLAY_MANIFEST: displayManifest,
  GIT_SHA: gitSha,
  HCAPTCHA_SITE_KEY: hCaptchaSiteKey,
  INSTALLATION_NAME: installationName,
  LOGO_THUMBNAIL: logoThumbnail,
  LOGO: logo,
  LOGO_DARK: logoDark,
  PRIVACY_URL: privacyURL,
  IS_ENTERPRISE: isEnterprise,
  TERMS_URL: termsURL,
  WIDGET_BRAND_URL: widgetBrandURL,
  DISABLE_USER_PROFILE_UPDATE: disableUserProfileUpdate,
  DEPLOYMENT_ENV: deploymentEnv,
} = window.globalConfig || {};

// advup — marca FIXA no front. Se o InstallationConfig reverter pra "Chatwoot" via
// seed/db:chatwoot_prepare, força advup. Nenhuma tela mostra Chatwoot.
const ADVUP_NAME = 'advup!';
const ADVUP_ICON = '/brand-assets/advup-icon-ref.png';
const advupIsChatwoot = v => !v || /chatwoot/i.test(String(v));
const advupName = advupIsChatwoot(installationName)
  ? ADVUP_NAME
  : installationName;
const advupBrand = advupIsChatwoot(brandName) ? ADVUP_NAME : brandName;
const advupSafeLogo = src =>
  !src || /logo_thumbnail|logo_dark|logo\.svg|chatwoot|woot/i.test(String(src))
    ? ADVUP_ICON
    : src;

const state = {
  apiChannelName,
  apiChannelThumbnail,
  appVersion,
  azureAppId,
  brandName: advupBrand,
  chatwootInboxToken,
  deploymentEnv,
  createNewAccountFromDashboard,
  directUploadsEnabled: parseBoolean(directUploadsEnabled),
  disableUserProfileUpdate: parseBoolean(disableUserProfileUpdate),
  displayManifest,
  gitSha,
  hCaptchaSiteKey,
  installationName: advupName,
  logo: advupSafeLogo(logo),
  logoDark: advupSafeLogo(logoDark),
  logoThumbnail: advupSafeLogo(logoThumbnail),
  privacyURL,
  termsURL,
  widgetBrandURL,
  isEnterprise: parseBoolean(isEnterprise),
};

export const getters = {
  get: $state => $state,
  isOnChatwootCloud: $state => $state.deploymentEnv === 'cloud',
  // advup — SEMPRE marca própria (29/10/2026). Era "o nome da instalação não é Chatwoot": se o InstallationConfig
  // voltasse ao padrão por seed, o painel inteiro reabria as peças do Chatwoot (novidades do blog deles, manual,
  // "ano em revisão", links de ajuda). Uma chave decide dezenas de telas — ela não pode depender de dado.
  isACustomBrandedInstance: () => true,
  isAChatwootInstance: $state => $state.installationName === 'Chatwoot',
};

export const actions = {};

export const mutations = {};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
